import { render, staticRenderFns } from "./aiAdminSetupPricingCard.vue?vue&type=template&id=12d32ff9&scoped=true"
import script from "./aiAdminSetupPricingCard.vue?vue&type=script&lang=js"
export * from "./aiAdminSetupPricingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12d32ff9",
  null
  
)

export default component.exports